/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle07Icon20Solid = forwardRef('NumberCircle07Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm2.905-11.99H7.119v1.47h3.797a17.192 17.192 0 0 0-1.82 3.164C8.593 11.78 8.277 12.9 8.149 14h1.966c.143-1.205.47-2.4.983-3.582.52-1.19 1.122-2.215 1.808-3.074V6.011Z" })));
});
